import { wrapReducer } from "@client/content/lib/helper";
import { generateId } from "@client/lib/random";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type InitSuccessActionData, type SetItemIdActionData } from "./actions";
import { type ReportModule } from "./types";

const reducer = (state: ReportModule.State, action: ReduxAction<any>): ReportModule.State => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: "Loading"
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.InitSuccess: {
      const { itemId, reportOptions } = action.data as InitSuccessActionData;
      return {
        ...state,
        itemId,
        reportOptions,
        status: "Ready"
      };
    }

    case Actions.SetItemId: {
      const { isDifferentReport, itemId } = action.data as SetItemIdActionData;
      return {
        ...state,
        itemId,
        reloadTrigger: isDifferentReport ? state.reloadTrigger : generateId()
      };
    }
    default:
      return state;
  }
};

export const defaultState: ReportModule.State = {
  error: null,
  id: "",
  status: "None",
  itemId: null,
  reloadTrigger: "",
  reportOptions: []
};
export const previewState: ReportModule.State = {
  ...defaultState,
  status: "Ready"
};
export default wrapReducer({ defaultState, reducer, previewState });
